var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrameLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 6,
    viewBox: "0 0 110 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75.8192,
    height: 5.59322,
    fill: "#C32A7C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80.791,
    width: 15.5367,
    height: 5.59322,
    fill: "#C32A7C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 101.299,
    width: 8.70057,
    height: 5.59322,
    fill: "#C32A7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameLine);
export default __webpack_public_path__ + "static/media/Frame-line.666861b27e8e93858a9b98e765a13dbf.svg";
export { ForwardRef as ReactComponent };